const CART_STORAGE_KEY = "vendor_cart";
const CART_UPDATED_EVENT = "vendor-cart-updated";

const notifyCartUpdated = () => {
  window.dispatchEvent(new Event(CART_UPDATED_EVENT));
};

const readCart = () => {
  const rawValue = localStorage.getItem(CART_STORAGE_KEY);

  if (!rawValue) {
    return [];
  }

  try {
    const parsed = JSON.parse(rawValue);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    localStorage.removeItem(CART_STORAGE_KEY);
    return [];
  }
};

const writeCart = (items) => {
  localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
  notifyCartUpdated();
};

export const getCartItems = () => readCart();

export const getCartCount = () => readCart().reduce((total, item) => total + Number(item.quantity || 0), 0);

export const addCartItem = (nextItem) => {
  const currentItems = readCart();
  const existingIndex = currentItems.findIndex((item) => Number(item.variant_id) === Number(nextItem.variant_id));

  if (existingIndex >= 0) {
    currentItems[existingIndex] = {
      ...currentItems[existingIndex],
      ...nextItem,
      quantity: Number(currentItems[existingIndex].quantity || 0) + Number(nextItem.quantity || 0)
    };
  } else {
    currentItems.push({
      ...nextItem,
      quantity: Number(nextItem.quantity || 0)
    });
  }

  writeCart(currentItems);
  return currentItems;
};

export const updateCartItemQuantity = (variantId, quantity) => {
  const nextItems = readCart()
    .map((item) => (
      Number(item.variant_id) === Number(variantId)
        ? { ...item, quantity: Number(quantity || 0) }
        : item
    ))
    .filter((item) => Number(item.quantity || 0) > 0);

  writeCart(nextItems);
  return nextItems;
};

export const removeCartItem = (variantId) => {
  const nextItems = readCart().filter((item) => Number(item.variant_id) !== Number(variantId));
  writeCart(nextItems);
  return nextItems;
};

export const clearCart = () => {
  localStorage.removeItem(CART_STORAGE_KEY);
  notifyCartUpdated();
};

export const setCartItems = (items) => {
  writeCart(items);
  return items;
};

export const subscribeToCartUpdates = (listener) => {
  window.addEventListener(CART_UPDATED_EVENT, listener);
  return () => window.removeEventListener(CART_UPDATED_EVENT, listener);
};
